import { UpdateOfficerDetailsPermissionsActionResult } from '../models/officer-details-action-result.models';
import { AgencyOfficerDetailsPermissions } from '../models/officer-details.models';

export const AGENCY_OFFICERS_STORE_KEY = 'agency-officers';

export interface IAgencyOfficersDetailsState {
  agencyOfficer: AgencyOfficerDetailsPermissions | null;
  actionResult: UpdateOfficerDetailsPermissionsActionResult | null;
  isLoading: boolean;
  isImageLoading: boolean;
}

export const initialState: IAgencyOfficersDetailsState = {
  agencyOfficer: null,
  actionResult: null,
  isLoading: false,
  isImageLoading: false,
};
